import { render, staticRenderFns } from "./UpdateSubscriberInformation.vue?vue&type=template&id=12561b0a&scoped=true&"
import script from "./UpdateSubscriberInformation.vue?vue&type=script&lang=js&"
export * from "./UpdateSubscriberInformation.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSubscriberInformation.vue?vue&type=style&index=0&id=12561b0a&scoped=true&lang=css&"
import style1 from "./UpdateSubscriberInformation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12561b0a",
  null
  
)

export default component.exports